// Yönlendirme korumaları: oturum ve platform modül izni.
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import type { Action, PermissionModule } from '@serota/domain';
import { ForbiddenState, Skeleton } from '@serota/ui-web';
import { useSession } from '../lib/session';

export function RequireAuth({ children }: { children: ReactNode }) {
  const { status } = useSession();
  const loc = useLocation();
  if (status === 'loading')
    return (
      <div className="sr-auth" aria-busy="true">
        <Skeleton height={40} width={200} />
      </div>
    );
  if (status === 'signedOut') return <Navigate to="/giris" replace state={{ from: loc.pathname }} />;
  return <>{children}</>;
}

export function RequirePerm({
  perm,
  action = 'view',
  children,
}: {
  perm: PermissionModule;
  action?: Action;
  children: ReactNode;
}) {
  const { can } = useSession();
  if (!can(perm, action))
    return (
      <div className="sr-page">
        <ForbiddenState card />
      </div>
    );
  return <>{children}</>;
}
